import { RouterUtils } from 'application/providers/RouterProvider';

import { buildAbsoluteUrl } from '@shared/lib';
import { BILLING_PAGE_PATH, StateParamValues } from '@entities/billing';

import { LicensesModalState } from './licensesModalReducer';
import { persistToEnableLicenses } from './persistToEnableLicenses';
import { redirectToBindCard } from './redirectToBindCard';
import { handleBindCardError } from './handleBindCardError';

const BILLING_PAGE_INFO_PATH = RouterUtils.generatePath(BILLING_PAGE_PATH, { state: StateParamValues.INFO });
export const URI_FOR_RETURN_CARD = buildAbsoluteUrl(BILLING_PAGE_INFO_PATH);

interface Props {
  companyId: string;
  state: LicensesModalState;
  getLinkForBindingCard: (uriForReturn: string, companyId: string) => Promise<string | undefined>;
  refetchBillingInfo: () => Promise<unknown>;
}

const createLicensesModalBindCard = ({ companyId, state, getLinkForBindingCard, refetchBillingInfo }: Props) => {
  const bindCard = async () => {
    try {
      const link = await getLinkForBindingCard(URI_FOR_RETURN_CARD, companyId);

      redirectToBindCard(link);
    } catch (e) {
      await handleBindCardError(e as Error, refetchBillingInfo);
    }
  };

  const handleBindCard = async () => {
    persistToEnableLicenses(state);

    await bindCard();
  };

  return { handleBindCard };
};

export default createLicensesModalBindCard;
